// extracted by mini-css-extract-plugin
export var messageSideLeft = "_lt-1";
export var messageSideRight = "_lt-2";
export var subscribeToBackInStockBubbleContainer = "_lt-0";